(function() {
	
	const createButton = which => {
		const btn = document.createElement('button');
		btn.setAttribute('type', 'button');
		btn.classList.add('no-ui', 'direction-button', which);
		btn.innerHTML = which === 'prev' ? '&larr;' : '&rarr;';
		
		btn.addEventListener('click', event => {
			const which = event.currentTarget.classList.contains('prev') ? 'prev' : 'next';
			const w = event.currentTarget.parentNode;
			
			const items = w.querySelectorAll('.embed-thumbnails-list-item');
			const current = parseInt( w.dataset.current || 0 , 10 );
			let next = which === 'prev' ? current - 1 : current + 1;
			if( next < 0 ) {
				next = items.length - 1;
			}
			else if(next >= items.length) {
				next = 0;
			}
			console.log(next);
			
			const currentItem = w.querySelector('.embed-thumbnails-list-item.current');
			if( currentItem ) {
				currentItem.classList.remove('current');
			}
			
			if( items[next] ) {
				w.dataset.current = next;
				items[next].classList.add('current');
			}	
		});
		
		return btn;
	};
	
	
	document.querySelectorAll('.embed-thumbnail').forEach( w => {
		const items = w.querySelectorAll('.embed-thumbnails-list-item');
		if( items.length < 2 ) {
			return;
		}
		
		items[0].classList.add('current');
		w.dataset.current = 0;
		
		// OK, add buttons prev & next  
		w.appendChild( createButton('prev') );
		w.appendChild( createButton('next') );
		
		
	});
}());